import BasketApi from "../Api/basket-api";
import config from "../../Config/config";
import {notice} from "../UI/notice";

export const deleteFromBasket = (evt, coupon, paymentVariant, events) => {
    evt.preventDefault();
    evt.stopPropagation();

    let self = evt.currentTarget;
    let id = self.dataset.id;
    let basket_id = self.dataset.basket_id;
    let item = self.closest('.js_item');

    item.classList.add('preloader');
    BasketApi.delete(id, basket_id, coupon, paymentVariant)
        .then(e => e.json())
        .then(content => {
            if (content.success) {
                events.dispatch(config.listeners.basket.deleted, content);
                let container = item.closest('section');
                item.parentNode.removeChild(item);
                let countItems = container.querySelectorAll('.js_item').length;
                if (!countItems) {
                   document.location.reload();
                }
            } else {
                notice('Ошибка удаления!');
            }
        })
        .catch(e => {
            console.log(e);
            notice('Ошибка удаления');
        })
        .finally(() => {
            item.classList.remove('preloader');
        });
};
